/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { CourierType } from './courier-type';

export const courierIcons = <CourierTypeConfig>{
  FED_EX: 'fa-brands fa-fedex',
  UPS: 'fa-brands fa-ups',
  DHL: 'fa-brands fa-dhl'
}

export const courierColors = <CourierTypeConfig>{
  FED_EX: '#4d148c',
  UPS: '#ffc400',
  DHL: '#d2002e'
}

export type CourierTypeConfig = { [key in CourierType]: string }
